module.exports = __webpack_public_path__ + "static/img/help_12excel_02.9e5402c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_12excel_02.png
// module id = 714
// module chunks = 140